// extracted by mini-css-extract-plugin
module.exports = {"logo":"MatchInfoEntry_logo__3c_j_","title":"MatchInfoEntry_title__Flvr_","subtitle":"MatchInfoEntry_subtitle__Mb7Jd"};